import type { CastingPosition } from '../api/castingReference';

// 保存/APIは x=難易度・y=ジャンル傾向を維持し、表示だけ横=傾向・縦=難易度へ変換する。
export const castingPositionToPlot = ({ x, y }: CastingPosition) => ({ left: y, top: 1 - x });
export const castingPositionFromPlot = (left: number, top: number): CastingPosition => ({
  x: Math.max(0, Math.min(1, 1 - top)),
  y: Math.max(0, Math.min(1, left)),
});

// Display only: values remain continuous and are never converted into artist ratings.
export function formatCastingContextSummary(context?: { applicable: boolean; position?: CastingPosition | null; difficultyRank?: string | null } | null) {
  if (!context) return '未設定';
  if (!context.applicable) return 'ジャンル変更のため再設定が必要です';
  if (!context.position) return context.difficultyRank ? `以前の設定：${context.difficultyRank}（位置は未設定）` : '未設定';
  const styles = ['ポップスライク', 'ポップス寄り', '中間', 'クラシック寄り', 'クラシックライク'];
  return `難易度 ${Math.round(context.position.x * 1000) / 10} / 100（易 → 難）・${styles[Math.min(4, Math.floor(context.position.y * 5))]}`;
}
